// utils/getTotemsImages.ts

import nzouNdlovu from "../assets/totems/NZOU.png";
import shumbaSibanda from "../assets/totems/SHUMBA.png";
import gwayiTshuma from "../assets/totems/GWAYI.png";
import hwesaMbeva from "../assets/totems/MBEVA.png";
import makombeHumba from "../assets/totems/HUMBA.png";
import maphosaNungu from "../assets/totems/NUNGU.png";
import mlamboSvosve from "../assets/totems/SVOSVE.png";
import moyoMwoyo from "../assets/totems/MWOYO.png";
import mpofuMhofu from "../assets/totems/MHOFU.png";
import ncubeSoko from "../assets/totems/SOKO.png";
import ngwenaNgwenya from "../assets/totems/NGWENA.png";
import nkomoGumbo from "../assets/totems/GUMBO.png";
import nyoniHungwe from "../assets/totems/HUNGWE.png";
import temboDube from "../assets/totems/TEMBO.png";

export interface TotemDetails {
  name: string;
  img: string;
}

export const getTotemsImages = (): TotemDetails[] => [
  { name: "Nzou/Ndlovu", img: nzouNdlovu },
  { name: "Shumba/Sibanda", img: shumbaSibanda },
  { name: "Gwayi/Tshuma", img: gwayiTshuma },
  { name: "Hwesa/Mbeva", img: hwesaMbeva },
  { name: "Maphosa/Nungu", img: maphosaNungu },
  { name: "Makombe/Humba", img: makombeHumba },
  { name: "Mlambo/Svosve", img: mlamboSvosve },
  { name: "Moyo/Mwoyo", img: moyoMwoyo },
  { name: "Mpofu/Mhofu", img: mpofuMhofu },
  { name: "Ncube/Soko", img: ncubeSoko },
  { name: "Ngwena/Ngwenya", img: ngwenaNgwenya },
  { name: "Nkomo/Gumbo", img: nkomoGumbo },
  { name: "Nyoni/Hungwe", img: nyoniHungwe },
  { name: "Tembo/Dube", img: temboDube },
];
